<template>
    <div class="flex-column" style="background-color:#fff;" v-if="checkin.template==2 || (checkin.template==0 && checkin.disable_homework == 0)">
        <div class="flex-row-between padding-20-30">
            <div class="flex-row work-clickable work-launch-wrap" @click.stop="emitAllWorkAction">
                <span class="work-tag">作</span>
                <span class="text-30-black">进行中的任务 ({{checkin.running_homework}}/{{checkin.total_homework}})</span>
            </div>
            <div class="flex-row work-clickable work-launch-wrap" @click.stop="emitAllWorkAction">
                <span class="text-30-blue">查看全部任务</span>
                <img class="icon-24" src="@/assets/icon/right_arrow_blue.png" />
            </div>
        </div>
        <div class="divider"></div>
        <div v-if="checkin.homework.length > 0" class="flex-column padding-20-30">
            <div class="work-item work-clickable work-launch-wrap" v-for="(item,index) in checkin.homework" :key="index" @click.stop="emitWorkDetailAction(item)">
                <div class="work-item-top flex-row" v-if="item.mode == 1 || item.mode == 2 || item.mode == 3">
                    <div class="tip-one" v-if="item.mode==1">每日打卡</div>
                    <div class="tip-one" v-if="item.mode==2">体温上报</div>
                    <div class="tip-one" v-if="item.mode==3">早读打卡</div>
                    <div class="tip-two">第{{item.days_current}}天</div>
                </div>
                <div class="work-item-top flex-row" v-else>
                    <div class="tip-one" v-if="item.mode==0">单次任务</div>
                    <div class="tip-one" v-if="item.mode==4">上课签到</div>
                </div>

                <div class="flex-row-between">
                    <div class="flex-column">
                        <span class="text-30-black">{{item.title}}</span>
                        <span class="text-24-99 top-10">截止时间：{{getEndDate(item.end_date)}} {{getEndTime(item.end_time)}}</span>
                    </div>
                    <div class="btn" :style="{backgroundColor: item.status == 1 ? '#12b7f5': '#999'}">
                        <span v-if="item.showing_submit_count == 0 && item.status == 1">提交任务</span>
                        <span v-if="item.showing_submit_count != 0 && item.status == 1">已交{{item.showing_submit_count}}次</span>
                        <span v-if="item.status == 0">已完成</span>
                        <span v-if="item.status == 3">未开始</span>
                    </div>
                </div>
            </div>
            <div class="publish-task" v-if="isAdmin && checkin.template != 2">+布置任务</div>
        </div>
        <div class="work-empty" v-if="checkin.homework.length < 1">
            <img src="https://cdn-xcxcustom.weiyoubot.cn/20200204/fe353c54b60eade42ef8ce6a8851f81b.png" class="empty-icon" />
            <span class="work-empty-text">提示：暂时还没有任务，请等待布置</span>
        </div>
    </div>
</template>

<script>
import { formatDate, getTimeString } from '@/utils/common.js'
export default {
    name: 'WorkBox',
    props: {
        checkin: {
            type: Object,
            default: () => {
                return {}
            }
        },
        enableWxLaunch: {
            type: Boolean,
            default: false
        },
        miniPath: {
            type: String,
            default: ''
        },
        miniProgramAppId: {
            type: String,
            default: ''
        },
        miniProgramUsername: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            
        };
    },
    computed:{
        isAdmin() {
            return (this.checkin.is_admin == 1 || this.checkin.is_owner == 1)
        }
    },
    methods: {
        emitAllWorkAction() {
            this.$emit('action', {
                type: 'allwork'
            })
        },
        emitWorkDetailAction(item) {
            this.$emit('action', {
                type: 'workdetail',
                wid: item && item.wid ? item.wid : ''
            })
        },
        getEndDate(date) {
            return formatDate(new Date(date * 1000), 'yyyy-MM-dd')
        },
        getEndTime(time) {
            return getTimeString(time)
        }
    },
};
</script>

<style lang="scss" scoped>
@function rem($px) {
    @return $px / 75 + rem;
}
.text-30-black {
    font-size: rem(30);
    color: #000;
    font-weight: 700;
}
.text-30-blue {
    font-size: rem(30);
    color: #12b7f5;
}
.icon-24 {
    width: rem(24);
    height: rem(24);
    margin-left: rem(10);
}
.work-tag {
    width: rem(38);
    height: rem(38);
    border-radius: rem(8);
    margin-right: rem(12);
    background-color: #f5b77a;
    color: #fff;
    font-size: rem(24);
    line-height: rem(40);
    text-align: center;
    flex: 0 0 auto;
}
.divider {
    width: 100%;
    height: 1px;
    background-color: #ececec;
}
.work-item {
    position: relative;
    height: rem(120);
    background-color: #f2f2f7;
    display: flex;
    flex-direction: column;
    border-left: rem(6) solid #12b7f5;
    margin-bottom: rem(20);
    padding: rem(30);
    justify-content: flex-end;
}
.work-clickable {
    cursor: pointer;
}
.work-launch-wrap {
    position: relative;
}
.work-item-top {
    position: absolute;
    top: 0;
    left: 0;

}
.tip-one {
    width: rem(110);
    height: rem(40);
    line-height: rem(40);
    text-align: center;
    background-color: #12b7f5;
    font-size: rem(22);
    color: #fff;
}
.tip-two {
    padding: 0 rem(10);
    border: 1px solid #12b7f5;
    color: #12b7f5;
    font-size: rem(24);
    text-align: center;
    height: rem(40);
    line-height: rem(40);
    box-sizing: border-box;
}
.text-24-99 {
    font-size: rem(24);
    color: #999;

}
.top-10 {
    margin-top: rem(10);
}
.btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: rem(50);
    padding: 0 rem(20);
    border-radius: rem(25);
    text-align: center;
    color: #fff;
    font-size: rem(22);
}
.publish-task {
    margin: 0 auto;
    width: rem(200);
    height: rem(64);
    border-radius: rem(32);
    background-color: #12b7f5;
    color: #fff;
    font-size: rem(28);
    display: flex;
    justify-content: center;
    align-items: center;
}
.work-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: rem(48) rem(30) rem(56);
}
.empty-icon {
    width: rem(180);
    height: rem(110);
    margin-bottom: rem(24);
}
.work-empty-text {
    font-size: rem(24);
    color: #999;
    line-height: 1.6;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkBox.vue